import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { PartyForm } from '@app/party/party.form';
import { UiActionTypeEnum, UiCommand, UiCommandEvent } from '@ui/cer-ui-types';
import { CerUiIcons } from '@ui/cer-ui-icons';
import { CerFormContext } from '@form/cer-form-context';
import { uiCmdExportExcel } from '@ui/cer-ui-commands';

export const uiCommandSelectReviewers: UiCommand = { id: 'uiCommandSelectReviewers', text: 'Tilføj anmeldere', iconCss: CerUiIcons.eye };

export class ProductPartyRoleForm extends CerFormAdapter {

  override viewSetInit(viewSet: CerFormViewSet): void {

    const view = ProductPartyRoleForm.productPartyRoleViewGet(true, true, false, null);
    view.paneTarget = 'main';
    viewSet.viewAdd(view);
  }

  public static productPartyRoleViewGet(includePartyNavigation: boolean = true, filterRoleReviewer: boolean = false, promoteExport: boolean = false, context: CerFormContext) {
    const params = [];
    if (includePartyNavigation) {
      params.push('$includePartyNavigation');
    }
    if (filterRoleReviewer) {
      params.push('$filterRoleReviewer');
    }
    const view = new CerFormView();
    const n: string = 'partyNavigation'
    view.viewMetadata = {
      name: 'titel-roller', dataApiName: 'ProductPartyRole', dataApiParams: params,
      text: 'Titelroller', textSingular: 'Titelrolle',
      titleFields: ['product', 'partyRole', n + '.num', n + '.name'],
      primaryKey: 'id', baseFields: ['id', 'history'],
      allowEdit: false, allowCreate: false
    };

    view.fieldMetadata = [
      { fieldType: 'product', width: '120px' },
      { fieldType: 'party' },
      { fieldType: 'partyRole' }
    ];
    // Add party columns through .partyNavigation
    const partyFieldMetadata = PartyForm.partyFieldMetaDataAsNavigation(n);
    view.fieldMetadata = view.fieldMetadata.concat(partyFieldMetadata);

    const hide: string[] = [n + '.publicId'];
    const show: string[] = [n + '.legacyId', n + '.comments', n + '.url'];
    view.fieldMetadata.filter(f => hide.includes(f.name)).forEach(f => f.visible = false);
    view.fieldMetadata.filter(f => show.includes(f.name)).forEach(f => f.visible = true);
    view.fieldMetadata.filter(f => f.visibleAdd == null).forEach(f => f.visibleAdd = true);
    view.fieldMetadata.filter(f => f.visibleEdit == null).forEach(f => f.visibleEdit = true);

    // Toolbar
    view.toolbarCommands = [];
    if (filterRoleReviewer) {
      view.toolbarCommands.push(uiCommandSelectReviewers);
      view.onCommandEvent = (e => { (e as any).context = context; ProductPartyRoleForm.onCommandEvent(e); })
    }
    // Excel toolbar+export
    if (promoteExport) {
      const exportExcel: UiCommand = Object.assign({ toolbarOverflow: 'show', toolbarShowTextOn: 'Both', align: 'Left' }, uiCmdExportExcel);
      exportExcel.toolbarOverflow = 'show';
      exportExcel.toolbarShowTextOn = 'Both';
      exportExcel.align = 'left';
      view.toolbarCommands.push(exportExcel);
      const exportOrder: string[] = [n + '.legacyId', n + '.name', n + '.attention', n + '.address', n + '.address2', n + '.phone', n + '.email'];
      view.fieldMetadata.forEach(f => {
        const idx = exportOrder.indexOf(f.name);
        f.visibleExport = idx != -1;
        f.orderExport = idx;
      });
    }

    // Field groups
    view.fieldGroupMetadata = [
      { idx: 1, name: 'identification', text: 'Identifikation', fields: ['id', 'product', 'partyRole'] },
      { idx: 3, name: 'party', text: 'Kontakt', fields: ['party', 'n.id', 'n.num', 'n.name', 'n.attention', 'n.comments'] },
      { idx: 3, name: 'partyAddress', text: 'Kontakt adresse', fields: ['n.address', 'n.address2', 'n.address3', 'n.country'] },
      { idx: 4, name: 'partySetup', text: 'Kontakt opsætning', fields: ['n.publicId', 'n.publicIdIsCompany', 'n.legacyId'] },
      { idx: 4, name: 'communication', text: 'Kontakt info', fields: ['n.phone', 'n.email', 'n.url', 'n.language'] },
      { idx: 4, name: 'other', text: 'Øvrige', fields: [] }
    ];
    view.fieldGroupMetadata.forEach(g => g.fields = g.fields.map(f => f.startsWith('n.') ? f.replace('n.', n + '.') : f));
    return view;
  }

  public static onCommandEvent(e: UiCommandEvent) {
    PartyForm.onCommandEventFilterChoiceRequest(e);
    if (e.actionType == UiActionTypeEnum.RefreshFromParent) {
      var name =  e.rowData?.name;
      if (name?.length > 0) {
           e.appComponent.viewMetadata.exportFileName = name;
      }
    }
    switch (e.commandId) {
      case uiCommandSelectReviewers.id:
        PartyForm.partySelectReviewers(e.formView.parentView /* Task view is the parent */, (e as any).context)
        break;
    }
  }
}

